import React from 'react';
import cx from 'classnames';

import Icon from '../Icon';
import Text from '../Text';

import styles from './ContextualContent.module.scss';
import usePresenter from './ContextualContent.presenter';
import getProps from './ContextualContent.props';
import { ContextualContentCombinedProps } from './types';


const ContextualContent: React.FC<ContextualContentCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    icon,
    text,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`contextualContent${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Error':
    case 'Help': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}/>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default ContextualContent;

